export const verval = [
  {
    title: "A. Verval PD",
    description:
      "Aplikasi yang bertujuan untuk menverifikasi data peserta didik yang ada di sekolah / lembaga",
    imgUrl:
      "https://raw.githubusercontent.com/kkafi09/pdpontren-kemenagkota/main/src/images/verval.png",
    link: "https://sso.data.kemdikbud.go.id/sys/login?appkey=348310F2-0262-4F5D-B7D1-41F92ECDCA93",
    deadline: "",
  },
  {
    title: "B. Verval SP",
    description:
      "Aplikasi yang bertujuan untuk melakukan verifikasi kesesuaian data proses pembelajaran setiap satuan pendidikan",
    imgUrl:
      "https://raw.githubusercontent.com/kkafi09/pdpontren-kemenagkota/main/src/images/verval-sp.png",
    link: "https://sso.data.kemdikbud.go.id/sys/login?appkey=199538EA-4DB7-4DC5-A9BD-64E5649C20A9",
    deadline: "",
  },
  {
    title: "C. Verval TIK",
    description:
      "Satuan Pendidikan digunakan untuk memastikan kepemilikan perangkat TIK di satuan pendidikan sebagai data dasar  dalam pelaksanaan Asessmen Kompetensi Minimal (AKM)",
    imgUrl:
      "https://raw.githubusercontent.com/kkafi09/pdpontren-kemenagkota/main/src/images/verval-tik.png",
    link: "https://sso.data.kemdikbud.go.id/sys/login?appkey=DCDC1C5D-7489-46FD-866D-1D86579891C5",
    deadline: "",
  },
  {
    title: "D. Bioan Paket",
    description: "Pendataan Asesmen Nasional Pendidikan Kesetaraan",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/bioan-paket.png?raw=true",
    link: "https://bioanpaket.kemdikbud.go.id/",
    deadline: "",
  },
  {
    title: "E. ANBK Nasional",
    description:
      "Asesmen Nasional Program evaluasi yang diselenggarakan oleh Kemendikbud untuk meningkatkan mutu pendidikan dengan memotret input, proses dan output pembelajaran di seluruh satuan pendidikan",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/anbk.png?raw=true",
    link: "https://anbk.kemdikbud.go.id/",
    deadline: "",
  },
  {
    title: "F. Cek NISN",
    description: "Aplikasi digunakan untuk mengecek NISN",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/cek-nisn.png?raw=true",
    link: "https://nisn.data.kemdikbud.go.id/",
    deadline: "",
  },
];
